import React from 'react'
import styled from '@emotion/styled'
import { Button } from '@labsavvyapp/components'
import { useProfileSettingsPageBusinessLogic } from '../../../logic/context'

const OrdersetSettingsHeaderControlsLayout = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  align-content: center;
  justify-content: center;
`

export const ProfileHeaderControls = () => {
  const pageLogic = useProfileSettingsPageBusinessLogic()

  const handleSaveProfileChangesClick = () => {
    // pageLogic?.goToCreateOrdersetPage()
  }

  return (
    <OrdersetSettingsHeaderControlsLayout>
      <Button radius="xl" size="md" uppercase variant="filled" onClick={handleSaveProfileChangesClick} disabled>
        Save Profile
      </Button>
    </OrdersetSettingsHeaderControlsLayout>
  )
}
